import { gql } from '@apollo/client'

const TripFragment = gql`
  fragment TripFragment on Trip {
    id
    saleStatus
    departureAt
    arrivalAt
    confirmedSeats
    serviceScore
    seats
    route {
      id
      name
    }
    routeService {
      id
      code
      businessClients {
        id
        name
        businessSites {
          id
          name
        }
      }
    }
    legSegments {
      id
      destination {
        id
        name
      }
      origin {
        name
      }
    }
    companyLine {
      id
      name
      company {
        id
      }
    }
    vehicle {
      id
      name
      externalID
      schedule {
        type
      }
    }
    driver {
      id
      name
    }
    itinerary {
      realDepartureTime
      place {
        id
        name
        timezone
      }
      arrival {
        time
        day
      }
      departure {
        time
        day
      }
    }
    timeline {
      user {
        id
        firstName
        lastName
        username
      }
      type
      correlationID
      createdAt
      placeID
    }
    notes {
      category
      message
      createdAt
      files {
        fileName
        path
      }
      cashFlow {
        type
        amount
      }
    }
    routeService {
      code
    }
    crewUsers {
      id
      firstName
      lastName
      username
    }
    firstStop @client
    lastStop @client
    intermediateStops @client
  }
`

export const GET_TRIP_SEGMENTS = gql`
  query GetTripSegments($input: tripSegmentsQueryInput!) {
    tripSegments(input: $input) {
      id
      tripID
      itinerary {
        place {
          id
          name
          timezone
        }
        departureTime
        arrivalTime
        day
      }
      basePrice
      availableSeatsNumber
      hasSelectableSeats
      segment {
        id
        origin {
          id
          name
        }
        destination {
          id
          name
        }
      }
      duration
    }
  }
`
export const GET_TRIP_SUBCAMPAIGN = gql`
  query GetTripSubcampaign($input: IncidenceSubcampaignInput!) {
    incidenceSubcampaign(input: $input) {
      id
      campaignID
      trip {
        id
        routeService {
          code
        }
        departureAt
        origin {
          name
        }
        destination {
          name
        }
        affectedLegSegments {
          origin {
            name
          }
          destination {
            name
          }
        }
      }
      coupons {
        id
        isActive
        supportInteractions {
          bookingID
          callStatus
          createdAt
          notes
          notificationChannel
          user {
            username
          }
        }
        originalBooking {
          id
          ticketsCount
          passengersCount
          coupon {
            code
          }
          origin {
            name
          }
          destination {
            name
          }
          buyer {
            firstName
            lastName
            email
            phone
          }
        }
        redeemedBooking {
          id
          ticketsCount
          passengersCount
          coupon {
            code
          }
          origin {
            name
          }
          destination {
            name
          }
          buyer {
            firstName
            lastName
            email
            phone
          }
        }
        status
        emails {
          id
          updatedAt
          status
        }
      }
    }
  }
`

export const GET_TRIP = gql`
  query GetTrip($tripId: ID!) {
    trip(input: { id: $tripId }) {
      ...TripFragment
    }
  }
  ${TripFragment}
`

export const GET_TRIP_BOOKINGS = gql`
  query GetTripBookings($input: TripBookingsQueryInput!) {
    tripBookings(input: $input) {
      id
      departureAt
      arrivalAt
      routeServiceCode
      origin {
        id
        name
        timezone
      }
      destination {
        id
        name
        timezone
      }
      itinerary {
        departureAt
        origin {
          id
          name
          timezone
        }
        destination {
          id
          name
          timezone
        }
        passengers {
          up
          down
          total
        }
        bookings {
          id
          vertical
          status
          destinationName
          checkInScore
          buyer {
            firstName
            lastName
            email
            phone
          }
          supportInteractions {
            createdAt
            notificationChannel
            callStatus
            notes
          }
          tickets {
            id
            status
            checkedIn
            couponCode
            seat {
              label
            }
            payment {
              status
              subtotal
              vat
              discount
            }
            passenger {
              id
              firstName
              lastName
            }
          }
        }
      }
    }
  }
`

export const GET_TRIP_TRACKING = gql`
  query GetTripTracking($input: TripTrackingQueryInput!) {
    tripTracking(input: $input) {
      total
      records {
        latitude
        longitude
      }
    }
  }
`

export const GET_TRIPS_VEHICLE_CONFLICT = gql`
  query GetTripsVehicleConflict($input: TripsVehicleConflictInput!) {
    tripsVehicleConflict(input: $input) {
      total
      items {
        id
      }
    }
  }
`

export const GET_TRIPS_DRIVER_CONFLICT = gql`
  query GetTripsDriverConflict($input: TripsDriverConflictInput!) {
    tripsDriverConflict(input: $input) {
      total
      items {
        id
      }
    }
  }
`

export const GET_VEHICLE_FOR_TRIP_DETAILS = gql`
  query GetVehicleV2($input: TVehicleInput!) {
    tvehicle(input: $input) {
      id
      name
      externalID
      template {
        capacity
      }
      licensePlates {
        number
      }
    }
  }
`
